module.exports = __webpack_public_path__ + "static/media/office.7dcf6a8c.jpg";